<template>
  <div>
    <Banner/>
    <AcercaHome/>
    <PlanComercial/>
    <Videos/>
    <CursosHome/>
    <Testimonios/>
    <Clientes/>
    <Podcast/>
    <Libro/>
    <Newsletter/>
    <Instagram/>
    <Contacto/>
  </div>
</template>

<script>
  import Banner from './Banner'
  import AcercaHome from './AcercaHome'
  import PlanComercial from './PlanComercial'
  import Videos from './Videos'
  import CursosHome from './CursosHome'
  import Testimonios from './Testimonios'
  import Clientes from './Clientes'
  import Podcast from './Podcast'
  import Libro from './Libro'
  import Newsletter from './Newsletter'
  import Instagram from './Instagram'
  import Contacto from './Contacto'

  export default {
    components: {
      Banner,
      AcercaHome,
      PlanComercial,
      Videos,
      CursosHome,
      Testimonios,
      Clientes,
      Podcast,
      Libro,
      Newsletter,
      Instagram,
      Contacto
    },
    metaInfo() {
        return { 
            meta: [
                { property: 'og:title', content: 'Hanniel Maldonado' },
                { property: 'og:site_name', content: 'Hanniel Maldonado' },
                { name: 'description', content:  'Mi preparación ha sido enfocada en áreas de Comercialización, Mercadotecnia y Negociación, lo que me ha permitido poder aplicar mejores prácticas y métodos de trabajo.'},
                { property: 'og:type', content: 'website'},   
                { property: 'og:url', content: 'https://hannielmaldonado.com/' }, 
                { property: 'og:image', content: 'https://hannielmaldonado.com/static/hanniel maldonado.jpg' }  
            ]
        }
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/Home.vue